<script>
import { mapState, mapActions } from 'vuex';
/* components */
import Leadboard from '@/views/Leadboard';
import DashboardCard from '@/components/DashboardCard';
import Profile from '@/components/Profile';
import Blur from '@/components/Blur';
import Slider from '@/components/Slider';
import Dropdown from '@/components/Dropdown';
import ModalBonus from '@/components/modal/ModalBonus';
/* tools */
import { mobile, currentGameTypes, gameTypeSetup } from '@/scripts/computed';
import { getBalances } from '@/scripts/api/account';
import { getStats, requestStatsRefresh } from '@/scripts/api/stats';
import { getAllConnections } from '@/scripts/api/connections';
import { wsConnection } from '@/scripts/modules/ws';
import { isEqual } from 'lodash';
import { getUserBonuses, getTiers } from '@/scripts/api/bonus';
import {
  getDropdownValue,
  findGame,
  sortConnections,
} from '@/scripts/utils/collection';
import Button from '@/components/Button';
import { secondsToTime } from '@/scripts/utils/time';
/*  */

export default {
  name: 'Dashboard',
  components: {
    Leadboard,
    /* Language, */
    DashboardCard,
    Profile,
    Blur,
    Slider,
    Dropdown,
    ModalBonus,
    Button,
  },
  data() {
    return {
      connections: null,
      stats: null,
      /*  */
      connected: true,
      /*  */
      lastParams: null,
      /*  */
      updateStatsSheduleId: null,
      liveCountDown: null,
      liveCountDownUpdaterId: null,
      visibleInfo: false,
    };
  },
  watch: {
    currentGameConnections(connections) {
      this.checkActivePlatform(connections);
    },
    activeConnectionId(activeConnectionId) {
      this.$nextTick(() => {
        this.updateStats({ activeConnectionId });
      });
    },
    activeGameType(activeGameType) {
      this.$nextTick(() => {
        this.updateStats({ activeGameType });
      });
    },
    stats(stats) {
      clearTimeout(this.liveCountDownUpdaterId);
      this.liveCountDownUpdaterId = null;

      this.liveCountDown = null;

      if (stats && stats.autoUpdates) {
        this.runLiveCountDown(stats.nextUpdateIn);
      }

      /*  */
      clearTimeout(this.updateStatsSheduleId);
      this.updateStatsSheduleId = null;

      if (stats && stats.nextUpdateIn) {
        this.setUpdateStatsShedule(stats.nextUpdateIn);
      }
    },
  },
  computed: {
    ...mapState([
      'user',
      'games',
      'allGamesTypes',
      'showModalBonus',
      'activeGame',
      'activeGameType',
      'activeTimeFilter',
      'activeGamePlatform',
    ]),
    banners() {
      const { gameTypeSetup, mobile } = this;

      if (!gameTypeSetup) return null;

      const { banners } = gameTypeSetup;

      if (!banners) return null;

      const result = banners
        .filter(item => (mobile ? item.mobile : !item.mobile))
        .map(({ image }) => image);

      return result;
    },
    currentGameSetup() {
      const { activeGame } = this;
      const result = findGame(activeGame);

      return result;
    },
    currentGameConnections() {
      const { connections, activeGame } = this;

      if (!connections) return null;

      const result = connections[activeGame];

      return result;
    },
    activeConnection() {
      const { currentGameConnections: connections, activeGamePlatform } = this;

      if (!connections || !connections.length) return null;

      const [first] = connections;
      let candidate = first;
      let result = null;

      if (activeGamePlatform) {
        const inConnections = connections.find(
          ({ platformID }) => platformID === activeGamePlatform
        );

        if (inConnections) candidate = inConnections;
      }

      if (candidate && candidate.status === 'connected') result = candidate;

      return result;
    },
    activeConnectionId() {
      const { activeConnection } = this;

      const result = activeConnection
        ? activeConnection.connectionID || null
        : null;

      return result;
    },
    dropdownGamePlatforms() {
      const { currentGameConnections } = this;

      if (!currentGameConnections || !currentGameConnections.length)
        return null;

      const withPlatforms = currentGameConnections.filter(
        ({ platformID }) => platformID
      );

      /* , status
      && status === 'connected' */

      const sorted = withPlatforms.sort(sortConnections);
      const dropdownElements = sorted.map(({ platformName, platformID }) => ({
        title: platformName,
        value: platformID,
      }));
      const result = dropdownElements;

      return result;
    },
    connectionUrl() {
      const { activeGame } = this;

      if (!activeGame) return null;

      const result = `/onboarding/connect-game/${activeGame}`;

      /* platform */
      /* , activeGamePlatform */
      /* ${activeGamePlatform ? `?platform=${activeGamePlatform}` : ''} */

      return result;
    },
    currentGameIsConnected() {
      const { activeGame } = this;
      const game = findGame(activeGame);

      if (!game) return false;
      const result = game.status === 'online';

      return result;
    },
    connectionDisabled() {
      const { currentGameConnections, currentGameSetup } = this;
      const { allowMultipleConnections: multi } = currentGameSetup;

      if (multi) return false;
      if (!currentGameConnections || !currentGameConnections.length)
        return false;

      const hasActive = currentGameConnections.some(
        ({ status }) => status === 'connected' || status === 'pending'
      );
      const result = hasActive && !multi;

      return result;
    },
    refreshInProcess() {
      const { stats } = this;
      const result = stats && stats.pendingUpdate;

      return result;
    },
    currentGameTypes,
    gameTypeSetup,
    mobile,
  },
  created() {
    this.allPlatforms = { title: 'All Platforms', value: null };

    Promise.all([
      getTiers(),
      getAllConnections(),
      this.updateBalance(),
      this.updateUserData(),
    ]).then(([{ items: tiers }, connections]) => {
      this.setTiers(tiers);
      this.connections = connections;
    });

    /* ws */
    wsConnection.setCallback('gameConnection.statsUpdated', () =>
      this.updateStats({ force: true })
    );
    wsConnection.setCallback(
      'wallets.balancesUpdate',
      this.updateUserRelatedData
    );
  },
  mounted() {},
  destroyed() {
    wsConnection.removeCallback('gameConnection.statsUpdated');
    wsConnection.removeCallback('wallets.balancesUpdate');
  },
  methods: {
    ...mapActions({
      setBalances: 'setBalances',
      setUserData: 'setUserData',
      setTiers: 'setTiers',
      setActiveGamePlatform: 'setActiveGamePlatform',
    }),
    updateUserRelatedData() {
      this.updateBalance();
      this.updateUserData();
    },
    updateBalance() {
      return getBalances().then(this.setBalances);
    },
    updateUserData() {
      return getUserBonuses().then(this.setUserData);
    },
    updateStats(inputParams = {}) {
      const { force = false } = inputParams;
      const gameConnectionID =
        inputParams.activeConnectionId || this.activeConnectionId;
      const gameTypeID = inputParams.activeGameType || this.activeGameType;
      const params = {
        gameConnectionID,
        gameTypeID,
      };

      const repetition = isEqual(params, this.lastParams);

      if (!force && repetition) {
        /* console.info('prevent odd request'); */

        return;
      }

      if (!gameConnectionID) {
        this.stats = null;
        this.lastParams = null;

        return;
      }

      if (!gameTypeID) return;

      this.lastParams = params;

      getStats(params).then(stats => {
        this.stats = stats;
      });
    },
    refreshStats() {
      const { activeConnectionId } = this;

      requestStatsRefresh(activeConnectionId).then(() => {
        /* console.info('stats refresh requested'); */
        this.updateStats({ force: true });
      });
    },
    getDataFromConnectionId(id = this.activeConnectionId) {
      const { connections } = this;
      let result = {};

      if (!connections) return result;

      Object.entries(connections).find(([gameId, gameConnections = []]) => {
        if (!gameConnections || !gameConnections.length) return result;

        const connection = gameConnections.find(
          ({ connectionID }) => `${connectionID}` === `${id}`
        );

        if (connection) {
          result = { gameId, connection: { ...connection } };
        }

        return connection;
      });

      return result;
    },
    checkActivePlatform(connections) {
      if (!connections || !connections.length) return;

      const connected = connections.find(
        ({ status }) => status === 'connected'
      );

      if (!connected) return;

      const { platformID } = connected;

      if (!platformID) return;

      this.setActiveGamePlatform(platformID);
    },
    setDropdownGamePlatform(val) {
      if (val) this.setActiveGamePlatform(val.value);
    },
    setUpdateStatsShedule(sec) {
      const timeout = (sec + 1) * 1000;

      this.updateStatsSheduleId = setTimeout(() => {
        this.updateStats({ force: true });
      }, timeout);
    },
    runLiveCountDown(sec) {
      this.liveCountDown = sec;

      this.liveCountDownUpdaterId = setInterval(() => {
        if (
          this.liveCountDown &&
          (this.liveCountDown > 0 || this.liveCountDown === 0)
        ) {
          this.liveCountDown -= 1;
        } else {
          this.liveCountDown = null;
        }
      }, 1000);
    },
    /* recheckUpdateParams(params, inputParams) {
      console.log('params', params);
      console.log('inputParams', inputParams);
      const { gameConnectionID, gameTypeID } = params;
      const {
        gameConnectionID: inputGameConnectionID,
        gameTypeID: inputGameTypeID,
      } = inputParams;
      const { gameId, connection } = this.getDataFromConnectionId(
        gameConnectionID
      );
      const { connectionID, status } = connection || {};

      console.log(gameId, connectionID, status, '|', gameTypeID);
      console.log('inputGameConnectionID', inputGameConnectionID);
      console.log('inputGameTypeID', inputGameTypeID);

      const result = null;

      return result;
    }, */
    getDropdownValue,
    secondsToTime,
  },
};
</script>

<template>
  <div class="dashboard">
    <!-- Modals -->
    <!--  -->
    <ModalBonus v-if="showModalBonus" />

    <!--  -->
    <Leadboard>
      <!-- refresh -->
      <template #refresh>
        <Button
          v-if="(stats && !stats.autoUpdates) || refreshInProcess"
          :class="{
            refresh: true,
            'is-active': refreshInProcess,
          }"
          :disabled="refreshInProcess"
          @click="refreshStats"
        >
          <template #icon>
            <img :src="require('@/assets/svg/refresh.svg')" />
          </template>
          Refresh
        </Button>
        <div v-if="liveCountDown" class="again">
          Your Stats will auto update in {{ secondsToTime(liveCountDown) }}
          <div
            :class="{
              tooltip: true,
              active: visibleInfo,
              'left-position':
                dropdownGamePlatforms && dropdownGamePlatforms.length,
            }"
          >
            <div class="tooltip__icon" @click="visibleInfo = !visibleInfo">
              <img :src="require(`@/assets/svg/info.svg`)" />
            </div>
            <div class="tooltip__content-wrapper">
              <div class="tooltip__close" @click="visibleInfo = !visibleInfo">
                <img :src="require('@/assets/svg/close.svg')" />
              </div>
              <div class="tooltip__content">
                Player Rush will auto update your stats and rewards as long as
                you continue to actively play the game. The countdown timer is
                an only estimate, so you may see your stats update before or
                after the time expires.
              </div>
            </div>
          </div>
        </div>
      </template>
      <!--  -->

      <!-- banners -->
      <template #banners>
        <Slider :banners="banners" />
      </template>

      <!-- platform -->
      <template #platform>
        <!-- game platform -->
        <Dropdown
          v-if="dropdownGamePlatforms && dropdownGamePlatforms.length"
          :force-value="
            getDropdownValue(activeGamePlatform, dropdownGamePlatforms)
          "
          :items="dropdownGamePlatforms"
          :set-first="false"
          :id="'platform'"
          @change="setDropdownGamePlatform"
        />
      </template>

      <!-- body -->
      <div class="dashboard__row dashboard__row--info">
        <div class="grid-block">
          <!-- user -->
          <div class="grid-block__left">
            <Profile :current-game-is-connected="currentGameIsConnected" />
          </div>

          <!-- >dashboard cards -->
          <div class="grid-block__wrapper-right">
            <Blur :active="!stats" :curvy="true">
              <template #primary>
                <div v-if="gameTypeSetup" class="grid-block__right">
                  <!-- map> -->
                  <DashboardCard
                    v-for="item in gameTypeSetup.dashboardFields"
                    :item="item"
                    :stats="stats"
                    :active-time-filter="activeTimeFilter"
                    :key="item.id"
                  />
                  <!-- <map -->
                </div>
              </template>
              <template #secondary>
                <div class="grid-block__empty">
                  <div class="empty">
                    <div class="empty__title">
                      This Game has not been connected
                    </div>
                    <div class="empty__text">
                      To connect this game please click below and follow the
                      instructions
                    </div>
                    <div class="empty__button" v-if="connectionUrl">
                      <Button
                        :to="connectionUrl"
                        :disabled="connectionDisabled"
                        class="boost"
                      >
                        Connect the game
                      </Button>
                    </div>
                  </div>
                </div>
              </template>
            </Blur>
          </div>
          <!-- <dashboard cards -->
        </div>
      </div>
    </Leadboard>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.dashboard {
  &__content {
    padding: 30px 30px 100px 0;
    display: flex;
    flex-direction: column;
    width: 100%;
    flex-grow: 1;
  }

  &__row {
    width: 100%;

    &--info {
      margin-top: 50px;
      margin-bottom: 50px;
    }
  }
}

.grid-block {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-self: start;

  &__right {
    flex-grow: 1;
    display: flex;
    flex-wrap: wrap;
    align-self: start;
    margin-top: -15px;
    margin-left: -15px;
  }

  &__left {
    width: 430px;
    flex-shrink: 0;
    margin-right: 15px;
    max-height: 420px;

    .profile {
      height: 100%;
    }
  }

  &__empty {
    padding: 10px 10px 36px;
    position: absolute;
    top: 107px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
  }

  &__wrapper-right {
    display: flex;
    flex-grow: 1;

    .root {
      display: flex;
      flex-grow: 1;
    }
  }
}

.empty {
  text-align: center;

  &__title {
    font-family: Poppins-Regular;
    font-size: 21px;
    line-height: 29px;
    color: #f95862;
  }

  &__text {
    font-family: Poppins-Light;
    font-size: 14px;
    line-height: 26px;
    color: #ffffff;
    margin-top: 14px;
  }

  &__button {
    width: 228px;
    margin: 50px auto 0;

    button,
    a {
      height: 40px !important;
    }
  }
}

.again {
  font-family: Poppins-Regular;
  font-size: 12px;
  line-height: 17px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0 15px;
  display: flex;
  align-items: center;

  .tooltip {
    margin-left: 8px;
  }
}

.tooltip {
  position: relative;

  &__close {
    display: none;
  }

  &__title {
    display: flex;
    align-items: center;
    font-family: Poppins-Regular;
    font-size: 12px;
    line-height: 17px;
    color: #ffc107;
  }

  &__icon {
    cursor: pointer;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    margin-top: 1px;
    position: relative;

    &:before {
      content: '';
      position: absolute;
      bottom: 100%;
      left: 50%;
      transform: translateX(-50%);
      border-left: 14px solid transparent;
      border-right: 14px solid transparent;
      border-top: 14px solid #1d2429;
      margin-bottom: 6px;
      display: none;
    }

    img {
      display: flex;
      width: 12px;
      height: 12px;
    }
  }

  &__content-wrapper {
    padding-bottom: 5px;
    position: absolute;
    padding-bottom: 6px;
    display: none;
    left: -12px;
    bottom: 16px;
    padding: 10px 2px 10px;
    z-index: 4;
  }

  &__content {
    width: 345px;
    height: auto;
    border-radius: 12px;
    box-shadow: 0 20px 40px 0 rgba(8, 7, 16, 0.5);
    background-color: #1d2429;
    font-family: Poppins-Regular;
    font-size: 12px;
    color: #ffffff;
    padding: 10px 10px 18px;
    line-height: 1.4;
  }
}

@media (min-width: $mobile) {
  .tooltip {
    &:hover {
      .tooltip__content-wrapper {
        display: block;
      }
    }
  }
}
@media (max-width: 1620px) {
  .tooltip.left-position {
    .tooltip__content-wrapper {
      left: auto;
      right: -15px;
    }
  }
}

@media (max-width: 1425px) {
  .tooltip {
    .tooltip__content-wrapper {
      left: auto;
      right: -15px;
    }
  }
}

@media (max-width: $mobile) {
  .dashboard {
    &__content {
      padding: 20px 0 80px;
    }

    &__row {
      &--info {
        margin-top: 20px;
      }
    }
  }

  .grid-block {
    flex-direction: column;
    align-items: center;

    &__left {
      margin: 0;
      width: 100%;
      max-width: none;
    }

    &__right {
      margin-top: 15px;
      padding: 0 15px;
      margin-left: -10px;
      justify-content: center;
    }

    &__wrapper-right {
      width: 100%;
      min-height: 300px;
    }

    &__empty {
      position: relative;
      top: auto;
      left: auto;
      transform: none;
    }
  }

  .again {
    position: fixed;
    left: 0;
    bottom: 50px;
    width: 100%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 30px;
    background: #181e1e;
    color: #ffffff;
    margin: 0;
    z-index: 9;
  }

  .tooltip {
    &.active {
      .tooltip__content-wrapper {
        display: flex;
      }
    }

    &__content-wrapper {
      position: fixed;
      top: 0;
      left: 0 !important;
      right: 0 !important;
      bottom: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(14, 15, 15, 0.9);
      padding: 0;
      align-items: flex-end;
    }

    &__content {
      width: 100%;
      border-radius: 0;
      border-top-left-radius: 50px;
      border-top-right-radius: 50px;
      font-size: 14px;
      line-height: 1.5;
      text-align: left;
      padding: 30px 20px;
      background: #131717;
      box-shadow: none;
    }

    &__close {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 10px;
      right: 0;
      width: 50px;
      height: 50px;

      img {
        display: flex;
        width: 16px;
        height: 16px;
      }
    }
  }
}
</style>
